export const FINANCING_SIGNUP_URL = "https://app.wayflyer.com/authn/signup";

export const FINANCING_PAGE_SEO_IMAGE =
  "https://cdn.sanity.io/images/1aendizt/redesign/8fc306006606a5d53e978d6c85d6da634030d49a-1200x630.png";
